import { v4 as uuidv4 } from 'uuid';
import BetArena from '../images/betarena.jpg';
import BetMart from '../images/betmart.jpg';
import Adams from '../images/adams.jpg';
import Pifortune from '../images/pifortune.jpg';
import DCC from '../images/dcc.jpg';
import PimallMetro from '../images/pimallmetro.jpg';
import kettlesub from '../images/kettlesub.jpeg';
import health from '../images/healthcare.jpeg';
import gas from '../images/gas.jpeg';
import Maltina from '../images/THH Image 08.jpg';
import Togao from '../images/insurance.jpg';
import Forex from '../images/forex.jpg';
import IEXport from '../images/import.jpg';
import Resavation from '../images/resavation.jpg';
import Todo from '../images/Todo.jpg';
import RustTodo from '../images/rust-ttodo.gif';

const projects = [

   {
    id: uuidv4(),
    name: 'NEXTJS, TS AND RUST TODO',
    desc:
      'this is a simple todo app built with nextjs and typescript, and it uses RUST AXUM in the backkend',
    img: RustTodo,
    link: 'https://nextjsandrusttodo.netlify.app/'
  },
   {
    id: uuidv4(),
    name: 'TASKIFY',
    desc:
      'This was built to master Vite + React and Typescript, It has the features of input, Edit, delete, strike mark and most importantly, drag and drop',
    img: Todo,
    link: 'https://tododragdroplist.netlify.app/'
  },
  {
    id: uuidv4(),
    name: 'Maltina Happiness Promo',
    desc:
      'A Maltina microsite project for promo and advert purpose',
    img: Maltina,
    link: 'https://maltinacampaign.netlify.app/'
  },
   {
    id: uuidv4(),
    name: 'Resavation',
    desc:
      'Resavation is an AI proptech company that allow tenants find verified properties online, inspect the property virtually and build their credit score by helping them with rental loan to pay their rent upfront in Nigeria',
    img: Resavation,
    link: 'https://www.resavation.com/'
  },
  {
    id: uuidv4(),
    name: 'Togao Consult’s Corporate Information',
    desc:
      'To contribute to the uplift of the standard of practice by offering relevant training courses and also offering quality services to the technical operations of insurance companies.',
    img: Togao,
    link: 'https://www.togaoconsults.com/'
  },
 
  {
    id: uuidv4(),
    name: 'TAE LOLU VENTURES',
    desc:
      'Nigeria is the most populous country in the African Continent and also the most populous black nation in the World.',
    img: IEXport,
    link: 'https://www.taelolu.com/'
  },
  {
    id: uuidv4(),
    name: 'Kettlesub',
    desc:
      'An e commerce website where users can purchase data subscribtions and other goods and services',
    img: kettlesub,
    link: 'https://kettlesub.com'
  },
  {
    id: uuidv4(),
    name: 'BetaCare',
    desc:
      'A health care organisation website',
    img: health,
    link: 'https://betacare.ng'
  },
 
  {
    id: uuidv4(),
    name: 'BetArena',
    desc:
      'A Crypto based Betting site, which has other features like casino gaming and crypto trading',
    img: BetArena,
    link: 'https://tchinonso.github.io/betarena'
  },
  {
    id: uuidv4(),
    name: 'BetMart',
    desc:
      'A pure betting site, just like the likes of Betkings and bet naija, You can place a bet between two teams, in football,tennis,basket ball and others.',
    img: BetMart,
    link: 'https://tchinonso.github.io/betmart'
  },
  {
    id: uuidv4(),
    name: 'AdamSonic',
    desc:
      'This website is a portfolio website for a medical and pharmaceutical firm, you can order their products and contact their staff',
    img: Adams,
    link: 'https://tchinonso.github.io/adams'
  },
   {
    id: uuidv4(),
    name: 'DCC',
    desc:
      'This project is yet to be completed, it is done halfway, only functional on mobile screens, it is also crypto related.',
    img: DCC,
    link: 'https://tchinonso.github.io/dcc'
  },
  
  {
    id: uuidv4(),
    name: "PIFORTUNE MARKET",
    desc:
      'A business crypto website, where customers can trade their pi coin and also purchase products and pay with pi coin.',
    img: Pifortune,
    link: 'https://pifortunemarket.site'
  },
  {
    id: uuidv4(),
    name: 'Pimallmetro plc',
    desc:
      'A business website where you can trade your pi coin and also purchase goods and services and pay with pi.',
    img: PimallMetro,
    link: 'https://pimallmetro.com'
  },
   {
    id: uuidv4(),
    name: 'Build Income With Forex Trading',
    desc:
      'EVER THOUGHT ABOUT A WORLD YOU COULD MAKE MONEY FOR YOURSELF AT YOUR PACE AND LIVE A STANDARD LIFE??.',
    img: Forex,
    link: 'https://www.assuredaimforex.com/'
  },
   {
    id: uuidv4(),
    name: 'Hellosa',
    desc:
      'A petrolium business',
    img: gas,
    link: 'https://hellosahq.com/'
  },
 
];

export default projects;
